// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4730":"3b53517f","4976":"3b53517f","5156":"3b53517f","8155":"3b53517f"}[chunkId] + ".chunk.css";
};